import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "90aa2bf3-9f96-41c0-9f26-16fc8aeb0f2a";

const statusLookup = [
    { ID: 'A', Text: "Active" },
    { ID: 'D', Text: "Delete" },
    { ID: 'I', Text: "Inactive" },
];

class PreviewGenerateCountRecords extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        console.log(this.props.dataSource);
        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }
    loadState() {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }
    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    height={'69vh'}
                    className="SearchOrderSalesResultOpenState"
                    scrolling={{ mode: "standard" }}
                    key={"rowid"}
                >
                    <Scrolling mode="virtual" />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={20} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column dataField="wh" caption="Location WH" allowEditing={false}></Column>
                    <Column dataField="location" caption="Location" allowEditing={false}></Column>
                    <Column dataField="customer" caption="Customer" allowEditing={false} visible={false}></Column>
                    <Column dataField="itemcode" caption="Item" allowEditing={false}></Column>
                    <Column dataField="description1" caption="Item Description - 1" allowEditing={false}></Column>
                    <Column dataField="onhand" caption="On Hand" allowEditing={false}></Column>
                    <Column dataField="available" caption="Available" allowEditing={false}></Column>
                    <Column dataField="dateintroduced" dataType="datetime" caption="Lot Date Introduced" allowEditing={false}></Column>
                    <Column dataField="dateavailable" dataType="datetime" caption="Lot Date Available" allowEditing={false}></Column>
                    <Column
                        dataField="itemstatus"
                        caption="Item Status"
                        allowEditing={false}
                        visible={false}
                        lookup={{ dataSource: statusLookup, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                            switch (cellData.value) {
                                case 'A':
                                    return <span>Active</span>;
                                case 'I':
                                    return <span>Inactive</span>;
                                default:
                                    return <span>{cellData.value}</span>;
                            }
                        }}
                    ></Column>
                    <Column
                        dataField="lotstatus"
                        caption="Lot Status"
                        allowEditing={false}
                        visible={false}
                        lookup={{ dataSource: statusLookup, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                            switch (cellData.value) {
                                case 'A':
                                    return <span>Active</span>;
                                case 'I':
                                    return <span>Inactive</span>;
                                case 'D':
                                    return <span>Delete</span>;
                                default:
                                    return <span>{cellData.value}</span>;
                            }
                        }}
                    ></Column>
                    <Column dataField="itemuddate1" dataType="datetime" caption="Item UD Date - 1" allowEditing={false} visible={false}></Column>
                    <Column dataField="itemuddate2" dataType="datetime" caption="Item UD Date - 2" allowEditing={false} visible={false}></Column>
                    <Column dataField="itemudreference1" caption="Item UD Reference - 1" allowEditing={false} visible={false}></Column>
                    <Column dataField="manufacturer" caption="Manufacturer" allowEditing={false} visible={false}></Column>
                    <Column dataField="oemmanufacturercode" caption="OEM Manufacturer Code" allowEditing={false} visible={false}></Column>
                    <Column dataField="lot" caption="Lot" allowEditing={false} visible={false}></Column>
                    <Column dataField="lotdescription1" caption="Lot Description - 1" allowEditing={false} visible={false}></Column>
                </DataGrid>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(PreviewGenerateCountRecords);